<script>
  import Loading from "../../UI/Loading.svelte";
  import Boton from "../../UI/Boton.svelte";

  import {createEventDispatcher} from 'svelte';
  import TipoDeMarcaje from "../../UI/TipoDeMarcaje.svelte";

  const dispatch = createEventDispatcher();

  export let dia;
  export let mensajeSiNoHayDias;

  const verInformacion = marcaje => dispatch('ver-informacion', marcaje);
  const editar = marcaje => dispatch('editar', marcaje);
  const marcarComoIncorrecto = marcaje => dispatch('incorrecto', marcaje);
  const pintaHora = hora => {
    const [h, m] = hora.split(':');
    return `${(h % 24).toString().padStart(2, '0')}:${m}`;
  };
</script>

<style>
    table {
        margin: var(--padding-global) 0;
    }

    thead tr th {
        border-bottom: 2px solid var(--verde) !important;
    }

    tbody tr {
        font-family: var(--familia-monoespaciada);
    }

    td:first-child,
    td:nth-child(4) {
        white-space: nowrap;
    }

    td:last-child {
        text-align: right;
    }

    td:only-child {
        text-align: center;
    }

    td {
        border-bottom: 1px solid var(--verde);
        vertical-align: middle;
    }
</style>

<table>
    <thead>
    <tr>
        <th>Tipo</th>
        <th>Marcaje</th>
        <th>Observaciones</th>
        <th>&nbsp;</th>
    </tr>
    </thead>
    <tbody>
    {#if dia}
        {#each dia.horas.filter(x => !x.borrado) as marcaje}
            <tr>
                <td>
                    <TipoDeMarcaje marcaje={marcaje}>
                        {marcaje.motivo.nombre}
                    </TipoDeMarcaje>
                </td>
                <td>{pintaHora(marcaje.hora)}</td>
                <td>{marcaje.observaciones || '—'}</td>
                <td>
                    <Boton on:click={() => verInformacion(marcaje)} icono="info" tipo="ok">
                        Ver&nbsp;información
                    </Boton>
                    <Boton on:click={() => editar(marcaje)} icono="edit">Corregir
                    </Boton>
                    <Boton on:click={() => marcarComoIncorrecto(marcaje)} icono="delete"
                           tipo="peligro">Marcar&nbsp;como incorrecto
                    </Boton>
                </td>
            </tr>
        {:else}
            <tr>
                <td colspan="7">{mensajeSiNoHayDias}</td>
            </tr>
        {/each}
    {:else}
        <tr>
            <td colspan="5">
                <Loading/>
            </td>
        </tr>
    {/if}
    </tbody>
</table>